import {
  Component,
  EventEmitter,
  HostListener,
  Output,
  ElementRef,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'migo-apps-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss',
})
export class ContextMenuComponent {
  @Output() logoutEmitter = new EventEmitter<void>();
  @Output() closeMenu = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  logout() {
    this.logoutEmitter.emit();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeMenu.emit();
    }
  }
}
